__turbopack_context__.v({
  "accordion-title": "d-TQQW_accordion-title",
  "content": "d-TQQW_content",
  "suporte": "d-TQQW_suporte",
  "tireDuvidas": "d-TQQW_tireDuvidas",
});
